var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "../../common/elements/Header.scss";
import { useContext, useEffect, useReducer } from "react";
import { sendRequest } from "../../../common/http";
import translate from "src/i18n/translate";
import WidgetLoader from "../../common/elements/WidgetLoader";
import UnauthorizedComponent from "src/features/insights/UnauthorizedComponent";
import { WmButton } from "@watermarkinsights/ripple-react";
import { ShareAccessModal } from "./ShareAccessModal";
import { AppContext } from "src/contexts/AppContext";
import { Link } from "react-router-dom";
import { scrollToTop } from "src/features/common/helper";
import ApiError from "src/features/common/elements/ApiError";
import { usePageTitle } from 'src/hooks/usePageTitle';
import { useIntl } from 'react-intl';
var defaultModalData = {
    title: "",
    nodeUuid: "",
    nodeType: "",
    selectedPeople: []
};
var defaultAction = {
    type: "",
    programs: [],
    showPrograms: true,
    institution: null,
    availablePeople: [],
    modalData: defaultModalData,
    uuid: "",
    nodeType: "",
    peopleWithAccess: [],
    apiError: false,
    organizations: null,
    showOrganizations: true
};
function updatePrograms(programs, uuid, peopleWithAccess) {
    var _a;
    return ((_a = programs === null || programs === void 0 ? void 0 : programs.map(function (progm) {
        return progm.uuid === uuid
            ? __assign(__assign({}, progm), { peopleWithAccess: peopleWithAccess }) : progm;
    })) !== null && _a !== void 0 ? _a : null);
}
function updateOrganizations(organizations, uuid, peopleWithAccess) {
    var _a;
    return ((_a = organizations === null || organizations === void 0 ? void 0 : organizations.map(function (org) {
        return org.uuid === uuid
            ? __assign(__assign({}, org), { peopleWithAccess: peopleWithAccess }) : org;
    })) !== null && _a !== void 0 ? _a : null);
}
function updateInstitution(institution, peopleWithAccess) {
    return institution
        ? __assign(__assign({}, institution), { peopleWithAccess: peopleWithAccess }) : null;
}
function actionUpdatePeopleWithAccess(state, action) {
    if (action.nodeType === "program") {
        return __assign(__assign({}, state), { programs: updatePrograms(state.programs, action.uuid, action.peopleWithAccess) });
    }
    else if (action.nodeType === "College" ||
        action.nodeType === "School") {
        return __assign(__assign({}, state), { organizations: updateOrganizations(state.organizations, action.uuid, action.peopleWithAccess) });
    }
    else {
        return __assign(__assign({}, state), { institution: updateInstitution(state.institution, action.peopleWithAccess) });
    }
}
var reducer = function (state, action) {
    switch (action.type) {
        case "updatePeopleWithAccess":
            return actionUpdatePeopleWithAccess(state, action);
        case "setPrograms": {
            var newLoadingStates = __assign(__assign({}, state.loadingStates), { programs: false });
            return __assign(__assign({}, state), { programs: action.programs, institution: action.institution, loadingStates: newLoadingStates, showLoader: computeShowLoader(newLoadingStates) });
        }
        case "setOrganizations": {
            var newLoadingStates = __assign(__assign({}, state.loadingStates), { organizations: false });
            return __assign(__assign({}, state), { organizations: action.organizations, loadingStates: newLoadingStates, showLoader: computeShowLoader(newLoadingStates) });
        }
        case "showPrograms":
            return __assign(__assign({}, state), { showPrograms: !state.showPrograms });
        case "showOrganizations":
            return __assign(__assign({}, state), { showOrganizations: !state.showOrganizations });
        case "toggleShareAccessModal":
            return __assign(__assign({}, state), { showShareAccessModal: !state.showShareAccessModal });
        case "setPeople": {
            var newLoadingStates = __assign(__assign({}, state.loadingStates), { people: false });
            return __assign(__assign({}, state), { availablePeople: action.availablePeople, loadingStates: newLoadingStates, showLoader: computeShowLoader(newLoadingStates) });
        }
        case "setModalData":
            return __assign(__assign({}, state), { modalData: action.modalData });
        case "setApiError": {
            var newLoadingStates = __assign(__assign({}, state.loadingStates), { programs: false, organizations: false, people: false });
            return __assign(__assign({}, state), { apiError: true, loadingStates: newLoadingStates, showLoader: computeShowLoader(newLoadingStates) });
        }
        default:
            return state;
    }
};
export default function AcademicsAndOffices(_a) {
    var auth = _a.auth;
    var initialState = {
        showPrograms: true,
        programs: null,
        institution: null,
        availablePeople: null,
        showShareAccessModal: false,
        modalData: defaultModalData,
        apiError: false,
        organizations: null,
        showOrganizations: true,
        loadingStates: {
            programs: true,
            organizations: true,
            people: true
        },
        showLoader: true
    };
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var intl = useIntl();
    // Add this line to set the page title
    var pageTitle = intl.formatMessage({ id: 'app.pageTitle.academicsAndOffices' });
    usePageTitle(pageTitle);
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setPrograms", programs: result.programs, institution: result.institution }));
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultAction), { type: "setApiError" }));
        };
        auth &&
            sendRequest({ uri: "/sa/programs", camelize: true }, applyResult, onError);
    }, [auth]);
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setOrganizations", organizations: result.organizations, institution: result.institution }));
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultAction), { type: "setApiError" }));
        };
        auth &&
            sendRequest({ uri: "/sa/organizations", camelize: true }, applyResult, onError);
    }, [auth]);
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setPeople", availablePeople: result }));
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultAction), { type: "setApiError" }));
        };
        auth &&
            sendRequest({ uri: "/sa/people", camelize: true }, applyResult, onError);
    }, [auth]);
    function expandTable() {
        dispatch(__assign(__assign({}, defaultAction), { type: "showPrograms" }));
        dispatch(__assign(__assign({}, defaultAction), { type: "showOrganizations" }));
    }
    function updatePeopleWithAccess(uuids, type, nodeUuid) {
        var peopleWithAccess = new Array(0);
        uuids.forEach(function (uuid) {
            var _a;
            var person = (_a = state.availablePeople) === null || _a === void 0 ? void 0 : _a.find(function (person) { return person.uuid === uuid; });
            person && peopleWithAccess.push(person);
        });
        dispatch(__assign(__assign({}, defaultAction), { type: "updatePeopleWithAccess", uuid: nodeUuid, nodeType: type, peopleWithAccess: peopleWithAccess }));
    }
    function toggleShareAccessModal(modalData) {
        dispatch(__assign(__assign({}, defaultAction), { type: "toggleShareAccessModal" }));
        if (modalData) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setModalData", modalData: modalData }));
        }
    }
    return (_jsx(_Fragment, { children: auth ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "page-header", children: _jsxs("div", { className: "title-container", children: [_jsx("h2", { id: "main-heading", className: "title zero-top-margin", children: translate("app.mainnav.academicsAndOffices") }), _jsx("div", { className: "title-description", children: translate("app.home.org.desc") })] }) }), state.showLoader ? (_jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" })) : (_jsxs(_Fragment, { children: [state.apiError && _jsx(ApiError, { containerClasses: "api-error" }), !state.apiError && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "org-node paper-card -nopadding org-management", role: "grid", "aria-readonly": "true", children: [_jsxs("div", { className: "orgnodeheader grid-row", role: "row", children: [_jsx("div", { className: "column", role: "columnheader", children: translate("app.drilldown.organization") }), _jsx("div", { className: "column", role: "columnheader", children: translate("app.academicsAndOffices.peopleWithAccess") })] }), state.institution && (_jsx(InstitutionRow, { institution: state.institution, showPrograms: state.showPrograms, showOrganizations: state.showOrganizations, expandTable: expandTable, toggleShareAccessModal: toggleShareAccessModal })), _jsxs("div", { id: "org-nodes", className: state.showPrograms && state.showOrganizations
                                                ? ""
                                                : "expand-node", children: [state.programs &&
                                                    state.programs.map(function (program, index) {
                                                        return (_jsx(ProgramRow, { program: program, showPrograms: state.showPrograms, toggleShareAccessModal: toggleShareAccessModal }, "".concat(program.uuid, " ").concat(index, "  ").concat(program.code)));
                                                    }), state.organizations &&
                                                    state.organizations.map(function (organization, index) {
                                                        return (_jsx(OrganizationRow, { organization: organization, showOrganizations: state.showOrganizations, toggleShareAccessModal: toggleShareAccessModal }, "".concat(organization.uuid, " ").concat(index, "  ").concat(organization.code)));
                                                    })] })] }), _jsx(ShareAccessModal, { toggleShareAccessModal: toggleShareAccessModal, updatePeopleWithAccess: updatePeopleWithAccess, showShareAccessModal: state.showShareAccessModal, availablePeople: state.availablePeople, modalData: state.modalData }, JSON.stringify(state.modalData))] }))] }))] })) : (_jsx(UnauthorizedComponent, {})) }));
}
var queryString = window.location.search;
function ProgramRow(_a) {
    var program = _a.program, showPrograms = _a.showPrograms, toggleShareAccessModal = _a.toggleShareAccessModal;
    var _b = useContext(AppContext), ctxInstitution = _b.institution, setBreadcrumb = _b.setBreadcrumb;
    return (_jsxs("div", { className: "orgnode grid-row hierarchy-level", role: "row", children: [_jsx("div", { className: "column", role: "gridcell", children: _jsxs("div", { className: "focus-space", children: [_jsx("div", { className: "treeitemlabel", children: _jsx(Link, { to: queryString.includes("locale")
                                    ? "/insights/institution/".concat(ctxInstitution === null || ctxInstitution === void 0 ? void 0 : ctxInstitution.platformUuid, "/program/").concat(program.uuid, "/").concat(queryString)
                                    : "/insights/institution/".concat(ctxInstitution === null || ctxInstitution === void 0 ? void 0 : ctxInstitution.platformUuid, "/program/").concat(program.uuid), id: "toolsNavItemLink", className: "hierarchy-link", onClick: function () {
                                    scrollToTop(".page-header");
                                    setBreadcrumb("academic-office");
                                }, children: program.name }) }), _jsx("p", { className: "node-info", children: _jsxs("span", { className: "infoheader", children: [translate("app.home.org.type"), _jsx("span", { className: "infodesc", children: translate("app.strategy.topProgramsByCatalog.program") })] }) }), _jsx("p", { className: "node-info", children: _jsxs("span", { className: "infoheader", children: [translate("app.home.org.code"), _jsx("span", { className: "infodesc", children: program.code })] }) })] }) }), _jsx("div", { className: "column cell", role: "gridcell", children: _jsx(ShareAccessButton, { node: program, toggleShareAccessModal: toggleShareAccessModal, nodeType: "program" }) })] }));
}
function InstitutionRow(_a) {
    var institution = _a.institution, showPrograms = _a.showPrograms, showOrganizations = _a.showOrganizations, expandTable = _a.expandTable, toggleShareAccessModal = _a.toggleShareAccessModal;
    var _b = useContext(AppContext), ctxInstitution = _b.institution, setBreadcrumb = _b.setBreadcrumb;
    return (_jsxs("div", { className: "orgnode grid-row", role: "row", children: [_jsxs("div", { className: "column", role: "gridcell", children: [_jsx("button", { "aria-expanded": showPrograms && showOrganizations, "aria-controls": "org-nodes", className: showPrograms && showOrganizations
                            ? "expand-button mdi  mdi-menu-down"
                            : "expand-button mdi  mdi-menu-right", "aria-label": "Toggle tree view of University", onClick: expandTable }), _jsxs("div", { className: "focus-space", children: [_jsx("div", { className: "treeitemlabel program-name", children: _jsx(Link, { to: queryString.includes("locale")
                                        ? "/insights/institution/".concat(ctxInstitution === null || ctxInstitution === void 0 ? void 0 : ctxInstitution.platformUuid, "/").concat(queryString)
                                        : "/insights/institution/".concat(ctxInstitution === null || ctxInstitution === void 0 ? void 0 : ctxInstitution.platformUuid), id: "toolsNavItemLink", className: "hierarchy-link", onClick: function () {
                                        scrollToTop(".page-header");
                                        setBreadcrumb("academic-office");
                                    }, children: institution === null || institution === void 0 ? void 0 : institution.name }) }), _jsx("p", { className: "node-info", children: _jsxs("span", { className: "infoheader", children: [translate("app.home.org.type"), _jsx("span", { className: "infodesc", children: translate("app.home.org.institution") })] }) }), _jsx("p", { className: "node-info", children: _jsxs("span", { className: "infoheader", children: [translate("app.home.org.code"), _jsx("span", { className: "infodesc", children: institution === null || institution === void 0 ? void 0 : institution.code })] }) })] })] }), _jsx("div", { className: "column cell", role: "gridcell", children: _jsx(ShareAccessButton, { node: institution, toggleShareAccessModal: toggleShareAccessModal, nodeType: "institution" }) })] }));
}
function ShareAccessButton(_a) {
    var node = _a.node, toggleShareAccessModal = _a.toggleShareAccessModal, nodeType = _a.nodeType;
    var intl = useIntl();
    var getAriaLabel = function (type, nodeName) {
        var typeFormatted;
        switch (type === null || type === void 0 ? void 0 : type.toLowerCase()) {
            case "program":
                typeFormatted = intl.formatMessage({
                    id: "app.strategy.topProgramsByCatalog.program"
                });
                break;
            case "institution":
                typeFormatted = intl.formatMessage({ id: "app.home.org.institution" });
                break;
            case "college":
                typeFormatted = intl.formatMessage({
                    id: "app.home.org.college"
                });
                break;
            case "school":
                typeFormatted = intl.formatMessage({
                    id: "app.home.org.school"
                });
                break;
            default:
                typeFormatted = type || "";
        }
        var nodeTypeText = (typeFormatted || "").toLowerCase();
        var baseLabel = "Share access to ".concat(nodeName).concat(nodeTypeText ? " ".concat(nodeTypeText) : "");
        return baseLabel;
    };
    if (!node) {
        return null;
    }
    var baseAccessibleLabel = getAriaLabel(nodeType, node.name);
    var hasPeopleWithAccess = Array.isArray(node.peopleWithAccess) && node.peopleWithAccess.length > 0;
    var _b = getUniqueFormattedNames(hasPeopleWithAccess ? node.peopleWithAccess : undefined, MAX_DISPLAYED_NAMES), peopleNamesForLabel = _b.limitedNames, additionalCount = _b.additionalCount;
    var peopleNamesLabel = __spreadArray(__spreadArray([], peopleNamesForLabel, true), (additionalCount > 0 ? ["+".concat(additionalCount, " more")] : []), true).filter(Boolean)
        .join(", ");
    var accessibleLabel = peopleNamesLabel
        ? "".concat(peopleNamesLabel, ", ").concat(baseAccessibleLabel)
        : baseAccessibleLabel;
    var handleOnClick = function () {
        return toggleShareAccessModal(__assign(__assign({}, defaultModalData), { title: node.name, nodeType: nodeType, nodeUuid: node.uuid, selectedPeople: hasPeopleWithAccess ? node.peopleWithAccess || [] : [] }));
    };
    return (_jsx(WmButton, { "button-type": "textonly", class: "-textonly hydrated", icon: hasPeopleWithAccess ? undefined : "f014", labelForIdenticalButtons: accessibleLabel, onClick: handleOnClick, children: hasPeopleWithAccess ? (_jsx("span", { children: _jsx(PeopleNames, { node: node }) })) : (_jsx("span", { "aria-hidden": "true", children: translate("app.academicsAndOffices.shareAccess") })) }));
}
var MAX_DISPLAYED_NAMES = 5;
var formatPersonName = function (person) {
    return [person.givenName, person.middleName, person.familyName]
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();
};
var getUniqueFormattedNames = function (people, limit) {
    if (limit === void 0) { limit = MAX_DISPLAYED_NAMES; }
    if (!people || people.length === 0) {
        return { limitedNames: [], additionalCount: 0 };
    }
    var uniqueNames = Array.from(new Set(people.map(function (person) { return formatPersonName(person); }).filter(Boolean)));
    var limitedNames = uniqueNames.slice(0, limit);
    return {
        limitedNames: limitedNames,
        additionalCount: Math.max(uniqueNames.length - limitedNames.length, 0)
    };
};
function PeopleNames(_a) {
    var node = _a.node;
    if (!node.peopleWithAccess) {
        return null;
    }
    var _b = getUniqueFormattedNames(node.peopleWithAccess, MAX_DISPLAYED_NAMES), limitedNames = _b.limitedNames, additionalCount = _b.additionalCount;
    if (!limitedNames.length && additionalCount === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [limitedNames.join(", "), additionalCount > 0 && " +".concat(additionalCount, " more")] }));
}
function OrganizationRow(_a) {
    var organization = _a.organization, showOrganizations = _a.showOrganizations, toggleShareAccessModal = _a.toggleShareAccessModal;
    var _b = useContext(AppContext), ctxInstitution = _b.institution, setBreadcrumb = _b.setBreadcrumb;
    return (_jsxs("div", { className: "orgnode grid-row hierarchy-level", role: "row", children: [_jsx("div", { className: "column", role: "gridcell", children: _jsxs("div", { className: "focus-space", children: [_jsx("div", { className: "treeitemlabel", children: _jsx(Link, { to: queryString.includes("locale")
                                    ? "/insights/institution/".concat(ctxInstitution === null || ctxInstitution === void 0 ? void 0 : ctxInstitution.platformUuid, "/organization/").concat(organization.uuid, "/").concat(queryString)
                                    : "/insights/institution/".concat(ctxInstitution === null || ctxInstitution === void 0 ? void 0 : ctxInstitution.platformUuid, "/organization/").concat(organization.uuid), id: "toolsNavItemLink", className: "hierarchy-link", onClick: function () {
                                    scrollToTop(".page-header");
                                    setBreadcrumb("academic-office");
                                }, children: organization.name }) }), _jsx("p", { className: "node-info", children: _jsxs("span", { className: "infoheader", children: [translate("app.home.org.type"), _jsx("span", { className: "infodesc", children: organization.type })] }) }), _jsx("p", { className: "node-info", children: _jsxs("span", { className: "infoheader", children: [translate("app.home.org.code"), _jsx("span", { className: "infodesc", children: organization.code })] }) })] }) }), _jsx("div", { className: "column cell", role: "gridcell", children: _jsx(ShareAccessButton, { node: organization, toggleShareAccessModal: toggleShareAccessModal, nodeType: organization.type }) })] }));
}
function computeShowLoader(loadingStates) {
    return loadingStates.programs || loadingStates.organizations || loadingStates.people;
}
